import FormInput from "./FormInput";
import ContactHead from "./ContactHead";

import Contact from "../Contact/Contact";

import ContactUsBanner from "./ContactUsBanner";
import { Box } from "@mui/material";

export default function ContactUs() {
  return (
    <div className="w-full">
      <ContactUsBanner />
      <ContactHead />
      <FormInput />
      <div className="w-full">
        <div className="w-full block md:hidden lg:hidden relative">
          <Box
            sx={{
              height: 400,
              width: {
                lg: "100%",
                md: "100%",
              },
              p: "6px",
              backgroundColor: "common.white",
              boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
              borderRadius: "4px",
            }}
          >
            <Box
              component="iframe"
              title="Google Maps"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d232.82799177757042!2d105.78540292504!3d20.98269897631562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135ad6ade40669b%3A0x86baf99a1ad26307!2sBT16B6!5e0!3m2!1svi!2s!4v1742283856160!5m2!1svi!2s"
              width="600"
              height="450"
              style={{ border: 0, width: "100%", height: "100%" }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Box>
        </div>
        <div className="w-full hidden md:block lg:block relative">
          <Box
            sx={{
              height: 600,
              width: {
                lg: "100%",
                md: "100%",
              },
              p: "6px",
              backgroundColor: "common.white",
              boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
              borderRadius: "4px",
            }}
          >
            <Box
              component="iframe"
              title="Google Maps"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d232.82799177757042!2d105.78540292504!3d20.98269897631562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135ad6ade40669b%3A0x86baf99a1ad26307!2sBT16B6!5e0!3m2!1svi!2s!4v1742283856160!5m2!1svi!2s"
              width="600"
              height="450"
              style={{ border: 0, width: "100%", height: "100%" }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Box>
        </div>
      </div>
      <div className="lg:mt-[-26px] mt-[-23px]">
        <Contact />
      </div>
    </div>
  );
}
